import { ApiUrlEnum } from '../enum';
import { del, postIm } from './api';

export default {
  loadAddImages: (td: FormData) => postIm(ApiUrlEnum.ADD_IMAGES, td),
  loadDeleteImages: (id: number) => del(`${ApiUrlEnum.DELETE_IMAGES}/${id}`),
};
